import { UnauthorizedComponent } from './unauthorized/unauthorized.component';

export const components = [UnauthorizedComponent];

export * from './unauthorized/unauthorized.component';
